<template>
	<div class="card-body">
		<div class="row row-cols-2 row-cols-xl-3 gx-4">
			<div
				v-for="feature in featuresMain"
				:key="feature"
				class="col text-truncate"
			>
				<span><i class="mdi mdi-check-bold"></i> {{ feature }} </span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DetailsFeatures',
	data() {
		return {
			featuresMain: [],
			featuresMainSecondRow: 1,
			hasParkingAssistants: false,
			featuresParkingAssistants: [],
			hasExtras: false,
			featuresExtras: [],
		}
	},
	props: {
		refData: Object,
		car: Object,
		carTitle: String,
	},
	created() {
		const featureText = []
		const extraText = []
		let features = this.car.ad

		// Delete Booleans which arent features
		delete features.envkvCompliant
		delete features.warranty
		delete features.metallic
		delete features.roadworthy
		delete features.bookableFeatures
		delete features.doors
		delete features.wheelFormula
		delete features.emissionSticker
		delete features.emissionClass
		delete features.condition
		delete features.interiorColor
		delete features.vehicleClass
		delete features.category
		delete features.make
		delete features.model
		delete features.countryVersion
		delete features.manufacturerColorName
		delete features.exteriorColor
		delete features.battery
		delete features.fuel

		// Check Radio DAB/TUNER

		if (features.radio && features.radio.length > 0) {
			features.radio.forEach((subfeature) => {
				featureText.push(this.refData[subfeature])
			})
			delete features.radio
		}

		// Check Parkinsassistants
		if (features.parkingAssistants && features.parkingAssistants.length > 0) {
			features.parkingAssistants.forEach((subfeature) => {
				//console.log(subfeature)
				featureText.push('Einparkhilfe ' + this.refData[subfeature])
			})
			delete features.parkingAssistants
		}

		for (let feature in features) {
			if (Boolean(features[feature]) && features[feature] === true) {
				let featureRefData = this.refData[feature]
				if (featureRefData !== '') {
					featureText.push(featureRefData)
				}
			} else if (
				Array.isArray(features[feature]) &&
				!feature.parkingAssistants &&
				features[feature].lenght > 0
			) {
				features[feature].forEach((subfeature) => {
					let featureRefData = this.refData[subfeature]
					if (featureRefData !== '') {
						featureText.push(featureRefData)
					}
				})
			} else if (
				!Number.isInteger(features[feature]) &&
				features[feature] !== '' &&
				features[feature] !== undefined
			) {
				let featureRefData = this.refData[features[feature]]
				if (featureRefData !== '' && featureRefData !== undefined) {
					featureText.push(featureRefData)
				}
			}
		}
		this.featuresMain = featureText.sort()
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
